import {Passenger, Reservation} from "@app/models";
import {
  BagAncillarieInt,
  BagPassangerInt,
  AncillariesCartInt,
  CartRequestPNRInt, 
  BookedCartInt, 
  AncillaryCartInt
} from "@interfaces/*";
import { StatusBagCarryOn} from "@app/enums";
import {ResponsePNRUdateInt} from "@app/interfaces/responsePNRUpdate.interface";

export class BagMapper {

  constructor() {}

  dataBagToReqtIssueBagTag( passenger: Passenger, currentBag: BagPassangerInt ) {
    return {
      _meta: {
        class: "CartPNRUpdate"
      },
      travelerInfo: {
        _meta: {
          class: "BookedTravelerCollection"
        },
        _collection: [{
          _meta: {
            class: "BookedTraveler"
          },
          baggageInfo: {
            _meta: {
              class: "BaggageInfo"
            },
            weight: currentBag.weightBag,
            unit: 'KG',
            codeBagge: currentBag.rficSubcode || ''
          },
          id: passenger.id
        }]
      }
    };
  }

  mapRedeemBagRquest(passenger: Passenger, extraAncillaries: BagAncillarieInt[], tierLevel: string, legCode: string): CartRequestPNRInt {
    let  [ firstBag ]  = extraAncillaries;
    let ancillaries: AncillariesCartInt = { _meta: { class: 'BookedTravelerAncillaryCollection' }, _collection: [] };
    const bagToRedeemed =  firstBag;
    const ancillariesCartInt: AncillaryCartInt = {
      _meta: { class: 'TravelerAncillary' },
      legCode,
      quantity: 1,
      ancillary: bagToRedeemed,
      benefitCodeId: tierLevel,
      options: []
    };
    ancillaries._collection.push(ancillariesCartInt);

    const bookedCartInts: BookedCartInt[] = [{
      _meta: {
        class: 'BookedTraveler',
      },
      id: passenger.id,
      isSelectedToCheckin: true,
      ancillaries: ancillaries,
      segmentChoices: null,
    }]

    let postData: CartRequestPNRInt = {
      cartId: null,//this.reservation.flightSummary.cartId,
      travelerInfo: {
        _collection: bookedCartInts,
        _meta: { class: 'BookedTravelerCollection' }
      },
      _meta: { class: 'CartPNRUpdate' }
    };
    return postData;
  }

  mapRedeemBagDTOtoResponse(data: ResponsePNRUdateInt, passengerId) {
      let [warning] = data._warnings._collection;
      let passenger = data.travelerInfo._collection.find(p => p.id === passengerId );

    return {
      warning,
      passenger,
    }
  }

  mapCarryOnBagRquest(resevation: Reservation): CartRequestPNRInt {
    const selected = resevation.passengers
    .filter((p) => p.checkinSelected && p.id && p.bagStackCarryon?.length > 0 )
    .map((p) => {

      return {
        _meta: {
          class: 'BookedTraveler',
        },
        id: p.id,
        isSelectedToCheckin: true,
        carryOnChecked: p.carryOnChecked !== StatusBagCarryOn.NONE && p.isCarryOnDroppedOff == false,
        ancillaries: null,
        segmentChoices: null,
      }
    });

    let postData: CartRequestPNRInt = {
      cartId: null,
      travelerInfo: {
        _collection: selected,
        _meta: { class: 'BookedTravelerCollection' }
      },
      _meta: { class: 'CartPNRUpdate' }
    };
    return postData;
  }

}
